import { useQuery } from 'data-fetching-client';
import { useCallback } from 'react';
import { GET_ADMINS, sendAdminEmail } from '../queries/adminQueries';
export function useAdmins() {
  const {
    data: admins = [],
    loading: adminsLoading,
    error: adminsError,
    refetch: refetchAdmins
  } = useQuery(GET_ADMINS, {
    variables: {}
  });
  return {
    admins,
    adminsLoading,
    adminsError,
    refetchAdmins
  };
}
export function useAdminEmail() {
  const emailAdmin = useCallback(async (adminUserId, listingId, adminInstall = false, permissions = []) => {
    // Use the data-fetching-client registered sendAdminEmail function
    return await sendAdminEmail(adminUserId, listingId, adminInstall, permissions);
  }, []);
  return {
    emailAdmin
  };
}